var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckboxSel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_checkbox_sel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0Z",
    fill: "#00C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M14.2869 6.51594L8.5495 12.339L6.16474 9.94667C5.86598 9.64791 5.38159 9.64791 5.08283 9.94667C4.78407 10.2454 4.78407 10.7298 5.08283 11.0286L8.00855 13.9543C8.15161 14.0985 8.34635 14.1797 8.5495 14.1797C8.75265 14.1797 8.94739 14.0985 9.09045 13.9543L15.3993 7.56737C15.6981 7.26861 15.6981 6.78422 15.3993 6.48546C15.1005 6.1867 14.6162 6.1867 14.3174 6.48546L14.2869 6.51594Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckboxSel);
export default __webpack_public_path__ + "static/media/ic_checkbox_sel.7d974f8736e7085b92297201bb86bfa8.svg";
export { ForwardRef as ReactComponent };